"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SingleReferenceHandler_1 = require("./SingleReferenceHandler");
const Shader_1 = require("../../tree/Shader");
class ShaderHandler extends SingleReferenceHandler_1.SingleReferenceHandler {
    constructor(sourceType, name) {
        super(sourceType, name, Shader_1.Shader, (obj) => [obj.stage.context]);
    }
    handle(obj, settings) {
        if (settings && settings.type) {
            const type = obj.stage.renderer.getSupportedShaderType(settings.type);
            if (!type) {
                console.warn("Shader has no implementation for render target: " + settings.type.name);
                obj[this.name] = undefined;
                return;
            }
            if (type !== settings.type) {
                return super.handle(obj, Object.assign({}, settings, { type }));
            }
        }
        super.handle(obj, settings);
    }
}
exports.ShaderHandler = ShaderHandler;
//# sourceMappingURL=ShaderHandler.js.map